// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__ERpsi","modalContent":"Modal_modalContent__pUpBt","closeBtn":"Modal_closeBtn__T6m0s","closeBtnIcon":"Modal_closeBtnIcon__+VLV0"};